<template>
    <div v-if="registration">
        <div v-for="formelement in registration.formElements" :key="formelement.formElementId">
            <strong>
              <p v-if="formelement.type !== 'header' && formelement.type !== 'repeater'" class="no-margin is-size-5">
                {{formelement.label}} <span class="red" v-if="formelement.dynamicTypeData.required">*</span>
              </p>
            </strong>
            <small v-if="formelement.toolTip" class="has-text-grey">
               - <em>{{formelement.toolTip}}</em>
            </small>
            <component :is="'kollecto-' + formelement.type" :userActionComponent="userAction" :formElement="formelement" class="form-element"></component>
        </div>
    </div>
</template>

<script>
import textarea from "./../../formelements/standard/textarea";
import radiobutton from "./../../formelements/standard/radiobutton";
import checkbox from "./../../formelements/standard/checkbox";
import select from "./../../formelements/standard/select";
import hidden from "./../../formelements/standard/hidden";
import image from "./../../formelements/standard/image";
import date from "./../../formelements/standard/textbox-date";
import number from "./../../formelements/standard/textbox-number";
import text from "./../../formelements/standard/text";
import toggle from "./../../formelements/standard/toggle";
import header from "./../../formelements/standard/header";
import repeater from "./../../formelements/standard/repeater";

export default {
  name: "formregistration",
  props: ["registration", "userAction"],
  components: {
    "kollecto-textarea": textarea,
    "kollecto-radiobutton": radiobutton,
    "kollecto-checkbox": checkbox,
    "kollecto-select": select,
    "kollecto-hidden": hidden, // missing
    "kollecto-image": image,
    "kollecto-date": date,
    "kollecto-number": number,
    "kollecto-text": text,
    "kollecto-toggle": toggle,
    "kollecto-header": header,
    "kollecto-repeater": repeater
  },
  data() {
    return {};
  }
};
</script>
